import { useEffect, useState } from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router'
import Cookies from 'universal-cookie'
import { Logo, Toast } from '@base'
import { paths } from '@routes'
import ArrowDown from '@assets/login/arrow-down.png'
import ArrowUp from '@assets/login/arrow-up.png'
import GooglePlay from '@assets/login/googlePlay.png'
import AppStore from '@assets/login/appStore.png'
import Cat1 from '@assets/login/category/ctg_1.png'
import Cat2 from '@assets/login/category/ctg_2.png'
import Cat3 from '@assets/login/category/ctg_3.png'
import Cat4 from '@assets/login/category/ctg_4.png'
import Cat5 from '@assets/login/category/ctg_5.png'
import Cat6 from '@assets/login/category/ctg_6.png'
import Cat7 from '@assets/login/category/ctg_7.png'
import { cookieKeys, strings } from '@constants'

import {
	MainWrapper,
	BackgroundImage,
	LoginContainer,
	Content,
	LinkWrapper,
	AnchorText,
	LogoContainer,
	GoogleImage,
	LinkedInWapper,
	PrivacyPolicyWrapper,
	FooterWapper,
	CategoryImage,
	CategoryContainer,
	CategoryTitle,
	CategoryServed,
	Container,
	CarouselContainer,
	ScrollContainer,
	InfoPanel,
	CategoryWapper,
	ScrollDownContainer,
} from './styles'
import Carousel from './Carousel'
import { isClient } from 'src/utils/adminFilter'

const categoryData = [
	{ img: Cat1, title: 'MS TMT BARS' },
	{ img: Cat2, title: 'MS SHEETS | PLATES' },
	{ img: Cat3, title: 'GI COIL' },
	{ img: Cat4, title: 'GP COIL' },
	{ img: Cat5, title: 'PPGI SHEETS' },
	{ img: Cat6, title: 'SCRAP' },
	{ img: Cat7, title: 'MS ANGLES' },
]

const Login = () => {
	const navigate = useNavigate()
	const location = useLocation()
	const [isActive, setActive] = useState(false)

	useEffect(() => {
		const cookies = new Cookies()
		const user = cookies.get(cookieKeys.user)
		if (user) {
			if (!isClient(user.role)) {
				if (!location.pathname.includes(paths.admin)) {
					navigate(paths.admin)
				}
			} else {
				if (user?.org_created) navigate(paths.home)
				else navigate(paths.login)
			}
		}
	}, [])

	const renderPrivacyPolicyText = () => {
		return (
			<PrivacyPolicyWrapper IsExtraSmall>
				This site is protected by reCAPTCHA and <br />
				the Google{' '}
				<AnchorText href='https://www.metalbook.co.in/terms-conditions' target='_blank'>
					{' '}
					Privacy Policy
				</AnchorText>{' '}
				and{' '}
				<AnchorText href='https://www.metalbook.co.in/terms-conditions' target='_blank'>
					{' '}
					Terms of Service
				</AnchorText>{' '}
				apply
			</PrivacyPolicyWrapper>
		)
	}

	const CategoryHandler = () => (
		<FooterWapper>
			<CategoryContainer>
				{categoryData.map((item, index) => (
					<CategoryWapper key={index} isRemove={index === 3 || index === 5}>
						<CategoryImage src={item?.img} />
						<CategoryTitle>{item?.title}</CategoryTitle>
					</CategoryWapper>
				))}
			</CategoryContainer>
			<CategoryServed>100+ Categories Served</CategoryServed>
		</FooterWapper>
	)

	const arrowHandler = () => {
		setActive(!isActive)
	}
	const scrollDownUi = () => (
		<>
			{isActive && (
				<InfoPanel show={true} amountPanelAnimation={true}>
					<ScrollContainer onClick={arrowHandler} isScrollUp>
						<img src={ArrowUp} alt='arrrow-up' />
						<CategoryServed>Scroll up to login</CategoryServed>
					</ScrollContainer>
					<div>
						<Carousel />
					</div>
					<div>
						{linkWapperUi()}
						{renderPrivacyPolicyText()}
					</div>
				</InfoPanel>
			)}
		</>
	)

	const linkWapperUi = () => (
		<LinkWrapper>
			<AnchorText href='https://www.metalbook.co.in/blogs' target='_blank'>
				{' '}
				{strings('blogs')}{' '}
			</AnchorText>
			|{' '}
			<AnchorText href='https://www.metalbook.co.in/' target='_blank'>
				{strings('website')}
			</AnchorText>{' '}
			|
			<AnchorText href='https://www.metalbook.co.in/about-us#email-form' target='_blank'>
				{' '}
				{strings('contact_us')}
			</AnchorText>
			<LinkedInWapper>
				<AnchorText href='https://apps.apple.com/us/app/metalbook/id6450207151' target='_blank'>
					<GoogleImage src={AppStore} />
				</AnchorText>
				<AnchorText href='https://play.google.com/store/apps/details?id=app.metalbook' target='_blank'>
					<GoogleImage src={GooglePlay} />
				</AnchorText>
			</LinkedInWapper>
		</LinkWrapper>
	)
	
	return (
		<MainWrapper>
			<BackgroundImage>
				{!isActive ? (
					<Container>
						<CarouselContainer>
							<Carousel />
							{CategoryHandler()}
						</CarouselContainer>
						<LoginContainer>
							<div>
								<LogoContainer>
									<Logo size='4.5rem' isLogin />
								</LogoContainer>
								<Content>
									<Outlet />
								</Content>
							</div>
							<div>
								{linkWapperUi()}
								{renderPrivacyPolicyText()}
							</div>
							<ScrollDownContainer>
								<ScrollContainer onClick={arrowHandler} isScrollDown>
									<CategoryServed>Scroll down to see benefits</CategoryServed>
									<img src={ArrowDown} alt='arrrow-down' />
								</ScrollContainer>
							</ScrollDownContainer>
						</LoginContainer>
					</Container>
				) : (
					<Container>{scrollDownUi()}</Container>
				)}
			</BackgroundImage>
			{/* <FooterImage src={footerImage} /> */}
			<Toast />
			{/* <GoogleDiv>
				{strings('msg_this_site_protected_recaptcha')}
				<AnchorText href='https://policies.google.com/privacy'> {strings('privacy_policy')}</AnchorText> {strings('and')}
				<AnchorText href='https://policies.google.com/terms'> {strings('terms_service')}</AnchorText> {strings('apply')}
			</GoogleDiv> */}
		</MainWrapper>
	)
}

export default Login
